module.exports = __webpack_public_path__ + "static/media/sns-24-2@3x.ceec8dc8.png";